import gql from 'graphql-tag'

/**
 * GraphQL fragment with every PAMM offer field the hierarchical tree view needs.
 *
 * Shared by both the Money Manager (`pammOffers`) and Agent (`pammAgentOffers`) queries
 * so the two pages produce an identical `PammOfferType` shape for `PammOffersTree`.
 */
export const PAMM_OFFER_TREE_FIELDS = gql`
  fragment PammOfferTreeFields on PammOfferType {
    id
    name
    # totalInvestments is a server-computed investor count and is populated for both
    # Money Manager and Agent offers; activeInvestmentCount is only set on Agent offers.
    totalInvestments
    currency
    managerId
    managerName
    totalDepositSum
    skygroundAccountId
    settings {
      agentChain {
        agentId
        client {
          id
        }
      }
      tradingInterval {
        type
        count
      }
      minDeposit
      minInitialInvestment
      minWithdrawal
      performanceFees {
        levels {
          level
          value
        }
        mode
      }
    }
  }
`
